import type { Schemas } from '#shopware'

export interface SelectedManufacturer {
    id: string
    name: string
    url: string | null
    extern_link: string | null
    technicalUrl: string
}

export function useSelectedManufacturers(category: Ref<Schemas['Category'] | null | undefined>) {
    return computed<SelectedManufacturer[]>(() => {
        const cf = (category.value?.customFields as Record<string, unknown> | undefined)
        return (cf?.selectedManufacturers as SelectedManufacturer[]) ?? []
    })
}